import React from 'react';
import './VerticalDivider.css'; // Import the CSS file

const VerticalDivider = () => {
  return <div className="vertical-divider-unique"/>; // Apply the unique CSS class
};

export default VerticalDivider;
